module.exports = __webpack_public_path__ + "img/users-multiple.2c734d36.svg";